import axiosInstance from "../Interceptor"

export const getReqAttributesApi = (payload) => {

	const prodUrl = process.env.REACT_APP_BASE_URL_TWO
	return (
		axiosInstance
			.get(`inventory/api/v1/${payload}/`)
			 
			.then(function (response) {
			 
				return response
			})
			.catch((error) => {
			 
				return error
			})
	)
}
